<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="通联会员ID">
                            <c-input name="biz_userid"></c-input>
                        </m-search-item>
                        <m-search-item label="关联用户">
                            <c-input name="user_realname"></c-input>
                        </m-search-item>
                        <m-search-item label="手机号">
                            <c-input name="phone"></c-input>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_purchase_supplier_export')"
                              prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!--账号类型-->
                <template #member_type="{data}">
                    <c-state tag dict="memberTypeDic" :value="data.member_type"></c-state>
                </template>
                <!--手机号绑定状态-->
                <template #bind_phone_status="{data}">
                    <c-state tag dict="completedDic" :value="data.bind_phone_status"></c-state>
                </template>
                <!--手机号绑定状态-->
                <template #bind_phone_status="{data}">
                    <c-state tag dict="completedDic" :value="data.bind_phone_status"></c-state>
                </template>
                <!--实名认证状态-->
                <template #is_identity_checked="{data}">
                    <c-state tag dict="completedDic" :value="data.is_identity_checked"></c-state>
                </template>
                <!--签约状态-->
                <template #is_sign_contract="{data}">
                    <c-state tag dict="completedDic" :value="data.is_sign_contract"></c-state>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_account_member_bindphone') && data.bind_phone_status == 0" icon="tf-phone" @click="$refs.allinpayBindPhone.open(data)">绑定手机</c-table-button>
                        <c-table-button v-if="auth('b_account_member_auth') && data.is_identity_checked == 0  && data.member_type == 3" icon="tf-ident" @click="$refs.allinpayMemberAuth.open(data)">个人实名认证</c-table-button>
                        <c-table-button v-if="auth('b_account_member_auth') && data.is_identity_checked == 0 && data.member_type == 2" icon="tf-ident" @click="$refs.allinpaySetCompany.open(data)">企业信息认证</c-table-button>
                        <c-table-button v-if="auth('b_account_member_bindcard')"  @click="$refs.allinpayBindBankcard.open(data.id)" icon="tf-card" :disabled="data.bind_phone_status == 0 || data.is_identity_checked == 0">提现绑卡</c-table-button>
                        <c-table-button v-if="auth('b_account_sign_protocol') && data.is_sign_contract == 0"  @click="signProtocol(data)" icon="tf-accept" :disabled="data.bind_phone_status == 0 || data.is_identity_checked == 0 || data.bankcard_count == 0">提现签约</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--绑定手机号弹窗-->
            <allinpay-bind-phone ref="allinpayBindPhone" @resolve="$refs.view.update()"></allinpay-bind-phone>
            <!--个人账户-实名认证-->
            <allinpay-member-auth ref="allinpayMemberAuth" @resolve="$refs.view.update()"></allinpay-member-auth>
            <!--企业账户-实名认证-->
            <allinpay-set-company ref="allinpaySetCompany" @resolve="$refs.view.update()"></allinpay-set-company>
            <!--绑卡-->
            <allinpay-bind-bankcard ref="allinpayBindBankcard" @resolve="$refs.view.update()"></allinpay-bind-bankcard>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import allinpayBindPhone from "@/pages/finance/allinpay_bind_phone.vue";
import allinpayMemberAuth from "@/pages/finance/allinpay_member_auth.vue";
import allinpaySetCompany from "@/pages/finance/allinpay_set_company.vue";
import allinpayBindBankcard from "@/pages/finance/allinpay_bind_bankcard.vue";

export default {
    components: {
        allinpayBindPhone,
        allinpayMemberAuth,
        allinpaySetCompany,
        allinpayBindBankcard
    },

    data() {
        return {
            workType: 31
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo', 'memberTypeDic', 'completedDic'])
    },

    methods: {
        signProtocol(data) {
            this.request({
                url: '/allinpay/sign/protocol',
                data: {
                    client_user_id: data.user_id
                },
                loading: false,  // 是否显示loading，
                success: (data, res) => {
                    window.open(data);
                },
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>